import { __awaiter } from 'tslib';
import 'long';
import '../proto/index.js';
import { ErrorType } from '../core/consts.js';
import '../core/metrics/logger.js';
import { Monitor, MonitorItem } from '../core/metrics/monitor.js';
import { ServiceIdentity } from '../core/service/RuntimeContext.js';
import '../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../adapter/manager/AdapterManager.js';
import '../adapter/manager/types.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import '../core/model/CommandMessage.js';

const RtcMetricsPrefix = 'rtc.api.invoke';
function RtcMetrics(target, name, descriptor) {
    const oldValue = descriptor.value;
    descriptor.value = function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            let startTime = 0;
            try {
                startTime = Monitor.performanceNow();
                const result = yield oldValue.call(this, ...args);
                this.resolve(ServiceIdentity.Monitor).emitDuration(RtcMetricsPrefix + MonitorItem.SuccessSuffix, startTime, {
                    name
                });
                return result;
            }
            catch (e) {
                this.resolve(ServiceIdentity.Monitor).emitDuration(RtcMetricsPrefix + MonitorItem.ErrorSuffix, startTime, {
                    name,
                    error: e.type ? `${e.type}:${ErrorType[e.type]}` : 'unknown'
                });
                throw e;
            }
        });
    };
    return descriptor;
}

export { RtcMetrics };
//# sourceMappingURL=RtcMetrics.js.map
